import React from 'react';

import { getUSState } from 'features/store/utils';
import { Typography } from 'ucl/components/text/Typography';

import { t, tRich } from 'state/intl/translations';

export const getLocalizedStoreAddress = (store: any) =>
  tRich('storeAddress', {
    name: '',
    address1: <Typography>{store?.physicalAddress?.address1}</Typography>,
    city: store?.physicalAddress?.city,
    stateProvince: getUSState(store?.physicalAddress?.stateProvince),
    postalCode: store?.physicalAddress?.postalCode,
    conditionalLinebreak: null,
    linebreak: '\n',
    defaultValue: '{address1}{linebreak}{city}, {stateProvince} {postalCode}',
  });

export const getLocalizedDeliveryAddress = (deliveryAddress: any) => {
  const addressLine2 = deliveryAddress.addressLine2
    ? t('unitNumber', { unitNumber: deliveryAddress.addressLine2 })
    : '';

  return t('deliveryAddressFormatted', {
    addressLine1: deliveryAddress.addressLine1,
    addressLine2,
    city: deliveryAddress.city,
    state: deliveryAddress.state,
    zip: deliveryAddress.zip,
    linebreak: '\n',
  });
};
